export default {"src":"/_next/static/media/templi-logo.5f47b1d9.svg","height":106,"width":80,"blurWidth":0,"blurHeight":0};